import { callApi } from './callApi';
import { EDGE_ROOT } from '../config';

export const call = (endpoint, params, _schema) => callApi({ serviceName: 'form', endpoint }, params, _schema, EDGE_ROOT);
